import { Crop, Location } from '@agroone/entities'
import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { BndButton } from '@bonduelle-it/storybook'
import { TranslatePipe } from '@ngx-translate/core'
import { IsOfflineDirective } from '../../directives'
import { TranslateConstantPipe } from '../../pipes'
import { SharedConstantService } from '../../services'
import { MenuOverlayComponent } from '../menu'

@Component({
  selector: 'app-scouting-info-overlay',
  templateUrl: './scouting-info-overlay.component.html',
  styleUrls: ['./scouting-info-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    TranslateConstantPipe,
    MatIconModule,
    RouterModule,
    IsOfflineDirective,
    MenuOverlayComponent,
    BndButton,
    DatePipe,
  ],
})
export class ScoutingInfoOverlayComponent {
  constantService = inject(SharedConstantService)

  readonly crop = input.required<Crop>()
  readonly isOffer = input<boolean | undefined>(false)
  readonly dateFormat = input<string>()

  readonly menu = viewChild.required<MenuOverlayComponent>('menu')

  public toggle() {
    this.menu().toggle()
  }

  public openMaps(location: Location) {
    if (location.longitude && location.latitude) {
      const url: string = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`
      window.open(url, '_blank')
    }
  }
}
